module.exports = __webpack_public_path__ + "img/logo_bvsk.cff1e969.png";